export var CustomerType;
(function (CustomerType) {
    CustomerType["PERSON"] = "PERSON";
    CustomerType["BUSINESS"] = "BUSINESS";
})(CustomerType || (CustomerType = {}));
export var CustomerBilling;
(function (CustomerBilling) {
    CustomerBilling["BILLED"] = "BILLED";
    CustomerBilling["NOT_BILLED"] = "NOT_BILLED";
})(CustomerBilling || (CustomerBilling = {}));
export var CustomerError;
(function (CustomerError) {
    CustomerError["LEGALNAME_REQUIRED"] = "LEGALNAME_REQUIRED";
    CustomerError["LEGALNAME_MIN_LENGTH"] = "LEGALNAME_MIN_LENGTH";
    CustomerError["DISPLAYNAME_REQUIRED"] = "DISPLAYNAME_REQUIRED";
    CustomerError["DISPLAYNAME_MIN_LENGTH"] = "DISPLAYNAME_MIN_LENGTH";
    CustomerError["FEDERALDOCUMENT_REQUIRED"] = "FEDERALDOCUMENT_REQUIRED";
    CustomerError["INVALID_FEDERALDOCUMENT"] = "INVALID_FEDERALDOCUMENT";
    CustomerError["USEREMAIL_REQUIRED"] = "USEREMAIL_REQUIRED";
    CustomerError["INVALID_USEREMAIL"] = "INVALID_USEREMAIL";
    CustomerError["CUSTOMER_USER_AUTHORIZATION_NOT_FOUND"] = "CUSTOMER_USER_AUTHORIZATION_NOT_FOUND";
    CustomerError["CUSTOMER_REQUIRED"] = "CUSTOMER_REQUIRED";
    CustomerError["INVALID_CUSTOMER"] = "INVALID_CUSTOMER";
    CustomerError["CUSTOMER_NOT_FOUND"] = "CUSTOMER_NOT_FOUND";
    CustomerError["INVALID_ACTIVE"] = "INVALID_ACTIVE";
    CustomerError["ACTIVE_REQUIRED"] = "ACTIVE_REQUIRED";
    CustomerError["INVALID_SKIPRUNS"] = "INVALID_SKIPRUNS";
    CustomerError["INVALID_LIMITRUNS"] = "INVALID_LIMITRUNS";
    CustomerError["INVALID_CONSULTANTEMAIL"] = "INVALID_CONSULTANTEMAIL";
    CustomerError["CONSULTANTEMAIL_REQUIRED"] = "CONSULTANTEMAIL_REQUIRED";
    CustomerError["INVALID_CURRENT_CUSTOMER"] = "INVALID_CURRENT_CUSTOMER";
})(CustomerError || (CustomerError = {}));
export var CustomerRole;
(function (CustomerRole) {
    CustomerRole["DEVICE_LIST_INSTANCES"] = "DEVICE_LIST_INSTANCES";
    CustomerRole["DEVICE_UPDATE"] = "DEVICE_UPDATE";
    CustomerRole["DEVICE_DELETE"] = "DEVICE_DELETE";
    CustomerRole["DEVICE_READ"] = "DEVICE_READ";
    CustomerRole["DEVICES_LIST"] = "DEVICES_LIST";
    CustomerRole["DEVICE_CREATE"] = "DEVICE_CREATE";
    CustomerRole["DEVICE_LINK"] = "DEVICE_LINK";
    CustomerRole["ROBOT_INSTANCE_CHANGE_SCHEDULE"] = "ROBOT_INSTANCE_CHANGE_SCHEDULE";
    CustomerRole["ROBOT_INSTANCE_RUN_CREATE"] = "ROBOT_INSTANCE_RUN_CREATE";
    CustomerRole["ROBOT_INSTANCE_DELETE"] = "ROBOT_INSTANCE_DELETE";
    CustomerRole["ROBOT_INSTANCE_CREATE"] = "ROBOT_INSTANCE_CREATE";
    CustomerRole["ROBOT_INSTANCE_RUN_READ"] = "ROBOT_INSTANCE_RUN_READ";
    CustomerRole["ROBOT_INSTANCE_LIST_RUNS"] = "ROBOT_INSTANCE_LIST_RUNS";
    CustomerRole["ROBOT_INSTANCE_READ"] = "ROBOT_INSTANCE_READ";
    CustomerRole["ROBOT_LIST_INSTANCES"] = "ROBOT_LIST_INSTANCES";
    CustomerRole["ROBOT_SAVE_NODES"] = "ROBOT_SAVE_NODES";
    CustomerRole["ROBOT_LOAD_NODES"] = "ROBOT_LOAD_NODES";
    CustomerRole["ROBOT_DELETE"] = "ROBOT_DELETE";
    CustomerRole["ROBOT_UPDATE"] = "ROBOT_UPDATE";
    CustomerRole["ROBOT_READ"] = "ROBOT_READ";
    CustomerRole["ROBOT_CREATE"] = "ROBOT_CREATE";
    CustomerRole["ROBOTS_LIST"] = "ROBOTS_LIST";
    CustomerRole["SUB_ROUTINES_DELETE"] = "SUB_ROUTINES_DELETE";
    CustomerRole["SUB_ROUTINES_LIST"] = "SUB_ROUTINES_LIST";
    CustomerRole["SUB_ROUTINES_UPDATE"] = "SUB_ROUTINES_UPDATE";
    CustomerRole["SUB_ROUTINE_CREATE"] = "SUB_ROUTINE_CREATE";
    CustomerRole["SUB_ROUTINE_READ"] = "SUB_ROUTINE_READ";
    CustomerRole["CUSTOMER_UPDATE"] = "CUSTOMER_UPDATE";
    CustomerRole["CUSTOMER_READ"] = "CUSTOMER_READ";
    CustomerRole["USER_CUSTOMER_AUTHORIZE"] = "USER_CUSTOMER_AUTHORIZE";
    CustomerRole["USERS_LIST"] = "USERS_LIST";
    CustomerRole["USER_READ"] = "USER_READ";
    CustomerRole["USER_CREATE"] = "USER_CREATE";
    CustomerRole["USER_UPDATE"] = "USER_UPDATE";
    CustomerRole["USER_DELETE"] = "USER_DELETE";
    CustomerRole["HISTORY_ROBOT_READ"] = "HISTORY_ROBOT_READ";
    CustomerRole["HISTORY_DEVICE_READ"] = "HISTORY_DEVICE_READ";
    CustomerRole["CUSTOMER_APPS_READ"] = "CUSTOMER_APPS_READ";
    CustomerRole["CUSTOMER_APPS_CREATE"] = "CUSTOMER_APPS_CREATE";
    CustomerRole["CUSTOMER_APPS_DELETE"] = "CUSTOMER_APPS_DELETE";
})(CustomerRole || (CustomerRole = {}));
